import { useState } from "react";

export default function Team({ members }) {
  const [selected, setSelected] = useState(null);

  return (
    <section id="team" className="px-6 py-20">
      <p className="mb-4 text-center text-sm font-semibold uppercase tracking-[0.22em] text-cyan-300">
        Our team
      </p>
      <h2 className="mb-12 text-center text-3xl font-bold leading-tight text-white md:text-5xl">
        Meet Our Team
      </h2>

      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3">
        {members.map((member) => (
          <article key={member.name} className="rounded-3xl border border-white/10 bg-white/10 p-7 text-center shadow-xl shadow-black/10 backdrop-blur transition hover:bg-white/[0.14]">
            <img src={member.image} alt={member.name} className="mx-auto mb-5 h-28 w-28 rounded-full object-cover ring-2 ring-cyan-300/30" />
            <h3 className="text-xl font-bold text-white">{member.name}</h3>
            <p className="mb-5 mt-1 text-sm text-slate-300">{member.role}</p>
            <button
              type="button"
              className="rounded-full bg-cyan-500 px-5 py-2.5 font-semibold text-white transition hover:bg-cyan-400"
              onClick={() => setSelected(member)}
            >
              Read Bio
            </button>
          </article>
        ))}
      </div>

      {selected && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/80 p-6 backdrop-blur">
          <div className="max-w-md rounded-3xl border border-white/10 bg-slate-900 p-7 text-white shadow-2xl">
            <h3 className="mb-2 text-2xl font-bold">{selected.name}</h3>
            <p className="mb-6 leading-relaxed text-slate-200">{selected.bio}</p>
            <button
              type="button"
              onClick={() => setSelected(null)}
              className="rounded-full bg-white px-5 py-2.5 font-semibold text-slate-950 transition hover:bg-cyan-100"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </section>
  );
}
